import { DataKeys } from "./plugins";
import { DeviceOptionItem, LocationOptionItem, OptionItem, SensorOptionItem, UserOptionItem, getPrefetchedDevices, getPrefetchedLocations, getPrefetchedSensors, getPrefetchedUsers } from "./requests";

export class SelectBoxManager {
    private static AllFilterValue = "0";
    public allUsers: Array<UserOptionItem>;
    public allLocations: Array<LocationOptionItem>;
    public allDevices: Array<DeviceOptionItem>;
    public allSensors: Array<SensorOptionItem>;

    public async initialise() {
        this.allUsers = await getPrefetchedUsers();
        this.allLocations = await getPrefetchedLocations();
        this.allDevices = await getPrefetchedDevices();
        this.allSensors = await getPrefetchedSensors();
    }

    public static readOptionsFromDom($selectEl: JQuery): Array<OptionItem<string>> {
        const result: Array<OptionItem<string>> = [];
        $selectEl.find("option").each((i, optionEl) => {
            result.push({ id: optionEl.value, text: optionEl.textContent });
        });
        return result;
    }

    public static setSelectedOptionAndRenderIfNotExists($selectEl: JQuery, id: string | number, text: string, triggerChange: boolean) {
        if ($selectEl.find(`option[value='${id}']`).length) {
            $selectEl.val(id);
        } else {
            $selectEl.append(new Option(text, id.toString(), true, true));
        }

        if (triggerChange) {
            $selectEl.trigger("change");
        }
    }

    public getLocationsForUser(userId: string | undefined) {
        if (userId && userId.toString() !== SelectBoxManager.AllFilterValue) {
            const user = this.allUsers.find(u => u.id == userId);
            if (user) {
                if (user.viewAllLocations) {
                    return this.allLocations;
                }
        
                return this.allLocations.filter(l => user.locationIds.indexOf(l.id) !== -1);
            }
        }
    
        return this.allLocations;
    }

    public getUsersForLocation(locationId: number | undefined): UserOptionItem[] {
        if (locationId && locationId.toString() !== SelectBoxManager.AllFilterValue) {
            return this.allUsers.filter(u => u.viewAllLocations || u.locationIds.indexOf(locationId) !== -1);
        }
    
        return this.allUsers;
    }
    
    public getDevicesForLocation(locationId: number | undefined) {
        if (locationId && locationId.toString() !== SelectBoxManager.AllFilterValue) {
            return this.allDevices.filter(d => d.locationIds.indexOf(locationId) !== -1);
        }
        
        return this.allDevices;
    }
    
    public getSensorsForDevice(deviceId: number | undefined) {
        return this.allSensors.filter(s => s.deviceId === deviceId);
    }
    
    public setOptions(el: JQuery, options: Array<OptionItem<string | number>>, selectedId: number | string | null, includeAllOption: boolean) {
        let selectedIdString: string;
        if (typeof selectedId === "number") {
            selectedIdString = selectedId.toString();
        } else if (typeof selectedId === "string") {
            selectedIdString = selectedId;
        } else {
            selectedIdString = el.val()?.toString();
        }

        el.children("option").remove();
        const effectiveOptions = [...options];
        if (includeAllOption) {
            effectiveOptions.splice(0, 0, { id: SelectBoxManager.AllFilterValue, text: "All" });
        }

        effectiveOptions.splice(0, 0, { id: "", text: ""}); // placeholder display option
        if (el.data(DataKeys.LazyLoad)) {
            el.data(DataKeys.LazyLoadItems, effectiveOptions);
            const selectedOption = effectiveOptions.find(o => o.id.toString() === selectedIdString);
            if (selectedOption) {
                SelectBoxManager.setSelectedOptionAndRenderIfNotExists(el, selectedOption.id, selectedOption.text, true);
            }
        } else {
            const optionEls = effectiveOptions.map(o => new Option(o.text, o.id.toString(), o.id.toString() === selectedIdString, o.id.toString() === selectedIdString));
            el.append(optionEls);
        }
    }
}
